<template>
    <div class="loginBackgroundColor">
        <a-row>
            <a-col :span="12">
                <div class="loginContainer">
                    <img class="img_size" src="../assets/img/zhulia-07.png" />
                    <h4 class="logoTitle">Signup</h4>
                    <div class="formContainer">
                        <a-form-model
                            ref="signupForm"
                            :model="form"
                            :rules="rules"

                        >
                                <a-col>
                                    <a-form-model-item label="Full Name" ref="fullName" prop="fullName">
                                        <a-input
                                            class=""
                                            v-model="form.fullName"
                                        />
                                    </a-form-model-item>
                                </a-col>
                                <a-col >
                                    <a-form-model-item label="Email Address" ref="email" prop="email">
                                    <a-input
                                        class=""
                                        v-model="form.email"
                                        
                                    />
                                </a-form-model-item>
                                </a-col>
                            
                         
                                <a-col>
                                    <a-form-model-item label="Password" ref="password" prop="password">
                                        <a-input
                                            class=""
                                            type="password" 
                                            autocomplete="off"
                                            v-model="form.password"
                                        />
                                    </a-form-model-item>
                                </a-col>
                                <a-col>
                                    <a-form-model-item label="Phone Number" ref="phoneNumber" prop="phoneNumber">
                                    <a-input
                                        class=""
                                        v-model="form.phoneNumber"
                                    />
                                </a-form-model-item>
                                </a-col>
                         
                            <div style="display:flex;justify-content: center;padding-bottom: 10px;">
                                 <a-spin class="spinner" :spinning="loading" />
                            </div>

                            <a-form-model-item>
                                <a-button class="loginButton" @click="handleSignup">
                                    Signup
                                </a-button>
                            </a-form-model-item>
                        </a-form-model>
                    </div>
                </div>
            </a-col>
            <a-col :span="12">
                <div class="carouselBgImg">
                    <a-carousel :after-change="onChange">
                        <div class="carousel_text">
                            Agriculture is our wisest pursuit, because it will in the end contribute most to real wealth, good morals & happiness
                        </div>
                    </a-carousel>

                </div>

            </a-col>
        </a-row>
    </div>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';

    export default {
        name: 'Login',
        data() {
            return {
                loading: false,
                form: {
                    email: '',
                    password: '',
                    fullName:'',
                    phoneNumber:''
                },
                rules: {
                    fullName: [
                        { required: true, message: 'Please enter your full name', trigger: 'change' }
                    ],
                    phoneNumber: [
                        { required: true, message: 'Please enter your phone number', trigger: 'change' }
                    ],
                    email: [
                        { required: true, message: 'Please enter your email' , trigger: 'blur'},
                        {
                            pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/),
                            message: 'Please enter valid email',
                            trigger: 'change'
                        },
                    ],
                    password: [
                        { required: true, message: 'Please enter your password', trigger: 'change' }
                    ]
                },
            };
        },
        computed: mapGetters(['IsAgentProfileAvailable']),
        methods:{
            ...mapActions(['signup', 'getAgentProfile','logout']),
            handleSignup() {
                this.$refs.signupForm.validate(valid => {
                    if (valid) {
                        this.loading = true;
                        let request_data = {
                            userName: this.form.fullName,
                            email: this.form.email,
                            password: this.form.password,
                            phoneNumber: this.form.phoneNumber
                        }
                        // console.log("request_data | ", request_data)
                      
                        this.signup(request_data).then(response => {
                            this.loading = false;
                            if(response.status === 202){
                                this.showSuccessAlert(response.data[0].message)
                                this.$refs.signupForm.resetFields();
                            }else{
                                this.loading = false
                                // console.log("Error 1 | ", response)
                                this.showErrorAlert(response.data[0].message)
                            }
                        },
                        error =>{
                            this.loading = false
                            // console.log("Error 2 | ", error)
                            this.showErrorAlert(JSON.stringify(error))
                        })
                    } else {
                        return false;
                    }
                });
            },
            showSuccessAlert(message) {
                this.$notification['success']({
                    message: message,
                });
            },
            showErrorAlert(message) {
                this.$notification['error']({
                    message: message
                });
            },
            onChange(a, b, c) {
                console.log(a, b, c);
            },
        }
    }
</script>

<style  scoped>

.carouselBgImg{
    background: url(../assets/img/carousel_pic.png) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    box-shadow: inset 0 0 0 100vw rgba(0,0,0,0.5);
}

.carousel_text{
    overflow-wrap: break-word;
    color: #ffffff;
    padding-left: 124px;
    padding-right: 124px;
    padding-top: 318px;
    padding-bottom: 286px;
    width: 471px;
    height: 164px;
    font-size: 24px;
    text-align: center;
    line-height: 39px;
}

.ant-carousel >>> .slick-slide {
  text-align: center;
  height: 100vh;
}

.ant-carousel >>> .slick-dots-bottom {
    padding-bottom: 96px;
    color:#418a49
}

/* .ant-carousel >>> .slick-dots li.slick-active button {
    background: #418a49;
    border:2px sol
    border-radius: 50%;
} */



.ant-carousel >>> .slick-slide h3 {
  color: #fff;
}

.spinner >>> .ant-spin-dot-item {
    background-color: #418a49;
}

.loginBackgroundColor{
    background-color: #ffffff;
}

.loginContainer{
    display: grid;
    justify-content: center;
    align-items: center;
    margin-top: 21px;
}

.img_size{
    max-width: 30%;
    padding-top: 30px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
}
.logoTitle{
    padding-top: 10px;
    padding-left: 166px;
    padding-right: 166px;
    font-size: 22px;
    text-align: center;
    line-height: 36px;
    color: #98c14b;
}

.formContainer{
    margin: 0 auto;
}

.loginButton{
    width: 379px;
    height: 45px;
    background-color: #418a49;
    color: #fff;
    border-radius: 5px;
    font-size: 18px;
}

.loginInput{
    width: 379px;
    height: 45px;
    border-radius: 5px;
}

.formContainer >>> .ant-form-item-label label {
    font-size: 16px;
    text-align: left;
    width: 135px;
    height: 24px;
    line-height: 26px;
    color: #000000;
}

</style>